import React from "react";

export default function LoadingContent({ content = "Ürünler yükleniyor" }) {
  return (
    <div
      className="w100p col marupside1"
      style={{
        padding: "1.25rem 0",
        gap: "0.75rem",
      }}
    >
      <div
        style={{
          fontSize: "1rem",
          fontWeight: 500,
          color: "#5f5f5f",
          letterSpacing: "0.02em",
        }}
      >
        {content}
      </div>

      <div
        style={{
          width: "min(260px, 80%)",
          height: "6px",
          borderRadius: "999px",
          background: "rgba(0,0,0,0.08)",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            width: "35%",
            height: "100%",
            borderRadius: "999px",
            background:
              "linear-gradient(90deg, rgba(210,170,60,0.25) 0%, rgba(210,170,60,0.9) 50%, rgba(210,170,60,0.25) 100%)",
            position: "absolute",
            top: 0,
            left: 0,
            animation: "beddoLoadingSlide 1.2s ease-in-out infinite",
          }}
        />
      </div>

      <style>
        {`
          @keyframes beddoLoadingSlide {
            0% {
              transform: translateX(-120%);
            }
            100% {
              transform: translateX(320%);
            }
          }
        `}
      </style>
    </div>
  );
}
